<ion-header>
  <ion-toolbar>
    <ion-back-button slot="start" (click)="back()" text=""></ion-back-button>
    <ion-title *ngIf="isNew">Neue Ticketart</ion-title>
    <ion-title *ngIf="!isNew">{{currentArt?.description}}</ion-title>
    <ion-buttons slot="end" *ngIf="!isNew" (click)="deleteArt()">
      <ion-button slot="icon-only" style="box-shadow: none;">
        <ion-icon name="fa-trash"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <h1 *ngIf="isNew">Neue Ticketart</h1>
  <h1 *ngIf="!isNew">{{currentArt?.description}}</h1>

  <h2>Bezeichnung</h2>
  <input type="text" placeholder="Vertrieb..." [(ngModel)]="description">
  
  <h2>Oberart (optional)</h2>
  <div class="filter-bttn" (click)="openMainArtPopover($event)">
    {{selectedMainArt?.description}} 
    <ion-icon name="fa-caret-down"></ion-icon>
  </div>

  <h2>Berechnen (optional)</h2>
  <div class="filter-bttn" (click)="openToCalculatePopover($event)">
    {{selectedToCalculate?.description}} 
    <ion-icon name="fa-caret-down"></ion-icon>
  </div>

  <h2>Intervall (optional)</h2>
  <input type="number" placeholder="60" min="1" [(ngModel)]="intervall">

</ion-content>

<ion-footer>
  <ion-toolbar class="ion-padding" style="padding-top: 0;">
    <div class="button main-button" (click)="save()">Speichern</div>
  </ion-toolbar>
</ion-footer>